/**
 * Read the `sub` claim from a JWT WITHOUT verifying it (the API verifies; the player
 * only needs the subject for the IndexedDB progress key). Returns null on any malformed input.
 */
export function decodeJwtSub(token: string): string | null {
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(b64);
    const payload = JSON.parse(json) as { sub?: unknown };
    return typeof payload.sub === 'string' && payload.sub.length > 0 ? payload.sub : null;
  } catch {
    // Malformed base64 or JSON — not a usable token; caller treats as "no user".
    return null;
  }
}
